import { Button, TextField } from "@material-ui/core";
import React, { useState } from "react";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import axios from "axios";

const ScenarioGroupInstanceDetails = (props) => {
  console.log("Data", props);
  const [jsonString, setJsonString] = useState(
    props.data.scenario_instance_details
  );

  const handleJsonChange = (event) => {
    setJsonString(event.target.value);
  };

  const handleSubmit = async () => {
    try {
      const parsedData = JSON.parse(jsonString);
      console.log("Parsed JSON:", parsedData);

      await axios.post("/edit_scenario_groups_open_loop_instance_details", {
        scenario_group_instance_info: props.data.scenario_instance_details,
        new_instance_detail: jsonString,
        scenario_group_id: props.data.scenario_group_id,
      });
      props.handleEditScenarioInstanceDetails();
    } catch (error) {
      console.error("Invalid JSON:", error);
    }
  };

  const handleReset = () => {
    setJsonString(
      JSON.stringify(props.data.scenario_instance_details, null, 4)
    );
  };

  return (
    <div style={{ padding: "21px", fontFamily: "Arial, sans-serif" }}>
      <MuiDialogTitle id="customized-dialog-title">
        Edit Instance Details
      </MuiDialogTitle>
      <TextField
        multiline
        fullWidth
        variant="outlined"
        rows={10}
        value={jsonString}
        onChange={handleJsonChange}
        style={{ marginBottom: "20px" }}
      />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          color="primary"
          style={{ marginRight: "10px" }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
        {/* <Button variant="contained" color="secondary" onClick={handleReset}>
          Reset
        </Button> */}
      </div>
    </div>
  );
};

export default ScenarioGroupInstanceDetails;
